import React from 'react';

const CollaboratorsListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_SUPER_ADMIN',
    'ROLE_COLLABORATOR_MANAGERS_ALL',
    'ROLE_COLLABORATOR_MANAGERS_LIST',
    'FRANCHISEE_COLLABORATOR_MANAGERS',
    'FRANCHISEE_COLLABORATOR_MANAGERS_ALL',
    'FRANCHISEE_COLLABORATOR_MANAGERS_LIST',
    'FRANCHISEE_COLLABORATOR_MANAGERS_ADD'
  ],
  routes: [
    {
      path: '/collaborators',
      component: React.lazy(() => import('./collaborators/collaborators_list'))
    }
  ]
};

const CollaboratorAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_SUPER_ADMIN',
    'ROLE_USERMANAGER_ADD',
    'ROLE_COLLABORATOR_MANAGERS_ADD',
    'FRANCHISEE_COLLABORATOR_MANAGERS_ADD'
  ],
  routes: [
    {
      path: '/collaborator/add',
      component: React.lazy(() => import('./collaborators/collaborator_add'))
    }
  ]
};

const CollaboratorEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_SUPER_ADMIN',
    'ROLE_USERMANAGER_ADD',
    'ROLE_COLLABORATOR_MANAGERS_EDIT',
    'FRANCHISEE_COLLABORATOR_MANAGERS_EDIT'
  ],
  routes: [
    {
      path: '/collaborator/:id',
      component: React.lazy(() => import('./collaborators/collaborator_edit'))
    }
  ]
};

const UsersListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_USERMANAGER_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/users',
      component: React.lazy(() => import('./users_list'))
    }
  ]
};

const UsersEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_USERMANAGER_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/user/:id',
      component: React.lazy(() => import('./user_edit'))
    }
  ]
};

const UsersAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_USERMANAGER_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/user/add',
      component: React.lazy(() => import('./user_edit'))
    }
  ]
};

const GroupsListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_GROUP_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/groups',
      component: React.lazy(() => import('./groups_list'))
    }
  ]
};

const GroupsEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_GROUP_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/group/:id',
      component: React.lazy(() => import('./group_edit'))
    }
  ]
};

const GroupsAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_GROUP_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/group/add',
      component: React.lazy(() => import('./group_add'))
    }
  ]
};

export {
  CollaboratorsListConfig,
  CollaboratorAddConfig,
  CollaboratorEditConfig,
  UsersListConfig,
  GroupsListConfig,
  GroupsAddConfig,
  GroupsEditConfig,
  UsersAddConfig,
  UsersEditConfig
};
